export default "/icon.png"